// store/modules/notificationPayment.js

import axios from 'axios'

const state = {
  notificationTabs: [],
  notificationList: [],
  totalCount: 0,
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    itemsPerPage: 10
  },
  loading: false,
  error: null
}

const getters = {
  getNotificationTabs: state => state.notificationTabs,
  getNotificationList: state => state.notificationList,
  getTotalCount: state => state.totalCount,
  getPagination: state => state.pagination,
  isLoading: state => state.loading,
  getError: state => state.error,

  // Get count berdasarkan status tertentu
  getCountByStatus: state => status => {
    const tab = state.notificationTabs.find(tab => tab.status === status)
    return tab ? tab.count : 0
  }
}

const mutations = {
  SET_NOTIFICATION_TABS (state, tabs) {
    state.notificationTabs = tabs
  },

  SET_TOTAL_COUNT (state, count) {
    state.totalCount = count
  },

  SET_NOTIFICATION_LIST (state, list) {
    state.notificationList = list
  },

  APPEND_NOTIFICATION_LIST (state, list) {
    state.notificationList = [...state.notificationList, ...list]
  },

  SET_PAGINATION (state, pagination) {
    state.pagination = pagination
  },

  SET_LOADING (state, loading) {
    state.loading = loading
  },

  SET_ERROR (state, error) {
    state.error = error
  },

  UPDATE_NOTIFICATION_COUNT (state, { status, count }) {
    const tab = state.notificationTabs.find(tab => tab.status === status)
    if (tab) {
      tab.count = count
    }
  },

  MARK_AS_READ (state, id) {
    const notification = state.notificationList.find(n => n.id === id)
    if (notification) {
      notification.is_read = true
    }
  },

  RESET_STATE (state) {
    state.notificationTabs = []
    state.notificationList = []
    state.totalCount = 0
    state.pagination = {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      itemsPerPage: 10
    }
    state.loading = false
    state.error = null
  }
}

const actions = {
  /**
   * Get notification tabs dengan count
   */
  async getNotificationTabs ({ commit, rootGetters }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const url = payload?.url || rootGetters['setup/getUrl']
      const response = await axios.get(`${url}v1/notification-payment/tabs`)

      if (response.data && response.data.data) {
        commit('SET_NOTIFICATION_TABS', response.data.data.tabs)
        commit('SET_TOTAL_COUNT', response.data.data.totalCount)
      }

      return response
    } catch (error) {
      console.error('Error fetching notification tabs:', error)
      commit('SET_ERROR', error.message || 'Gagal memuat notifikasi')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /**
   * Get notification list berdasarkan status
   */
  async getNotificationList ({ commit, rootGetters }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      const url = payload?.url || rootGetters['setup/getUrl']
      const params = {
        status: payload.status || 'all',
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
        search_by: payload.search_by,
        option_payment: payload.optionPayment,
        sortBy: payload.sortBy || 'created_at',
        sortOrder: payload.sortOrder || 'desc',
        phase: payload.phase || ''
      }

      console.log('masuk sini kah?', params)

      const response = await axios.get(`${url}v1/notification-payment/list`, { params })

      if (response.data && response.data.data) {
        // Jika loadMore = true, append data. Jika tidak, replace
        if (payload.loadMore) {
          commit('APPEND_NOTIFICATION_LIST', response.data.data.data)
        } else {
          commit('SET_NOTIFICATION_LIST', response.data.data.data)
        }

        commit('SET_PAGINATION', response.data.data.pagination)
      }

      return response
    } catch (error) {
      console.error('Error fetching notification list:', error)
      commit('SET_ERROR', error.message || 'Gagal memuat daftar notifikasi')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /**
   * Get total count untuk status tertentu
   */
  async getTotalByStatus ({ commit, rootGetters }, payload) {
    try {
      const url = payload?.url || rootGetters['setup/getUrl']
      const status = payload.status

      const response = await axios.get(`${url}/api/notification-payment/total/${status}`)

      if (response.data && response.data.data) {
        commit('UPDATE_NOTIFICATION_COUNT', {
          status: status,
          count: response.data.data.total
        })
      }

      return response
    } catch (error) {
      console.error('Error fetching total by status:', error)
      throw error
    }
  },

  /**
   * Get summary/overview
   */
  async getSummary ({ commit, rootGetters }, payload) {
    commit('SET_LOADING', true)

    try {
      const url = payload?.url || rootGetters['setup/getUrl']
      const response = await axios.get(`${url}v1/notification-payment/summary`)

      return response
    } catch (error) {
      console.error('Error fetching summary:', error)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  /**
   * Mark notification as read
   */
  async markAsRead ({ commit, rootGetters }, payload) {
    try {
      const url = payload?.url || rootGetters['setup/getUrl']
      const id = payload.id

      const response = await axios.put(`${url}/api/notification-payment/${id}/read`)

      if (response.data) {
        commit('MARK_AS_READ', id)
      }

      return response
    } catch (error) {
      console.error('Error marking as read:', error)
      throw error
    }
  },

  /**
   * Refresh semua data notifikasi
   */
  async refreshAll ({ dispatch }, payload) {
    await Promise.all([
      dispatch('getNotificationTabs', payload),
      dispatch('getNotificationList', { ...payload, page: 1 })
    ])
  },

  /**
   * Reset state
   */
  resetState ({ commit }) {
    commit('RESET_STATE')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
